import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { filter, first, flatMap, withLatestFrom } from 'rxjs/operators';
import * as fromRoot from 'app/core/store';
import * as fromAuth from 'app/auth/store';
import { environment } from 'environments/environment';

@Injectable()
export class SessionsInterceptor implements HttpInterceptor {
    constructor(private store: Store<fromRoot.AppState>) {}
    

  intercept(req: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<any>> {
     // Anything not aimed at our own API (Azure AD discovery/token calls made by
     // angular-oauth2-oidc, fonts, CDNs...) never needs our session token and must
     // not be blocked waiting for one that can only exist once login completes.
     if (!req.url.startsWith(environment.apiUrl)) {
        return next.handle(req);
     }
     // These do not need Sessions Token
     if(!req.url.startsWith("http") || // Resources for Material
        req.url == `${environment.apiUrl}/oauth/forgotpassword` ||  // Forgot Password
        req.url == `${environment.apiUrl}/oauth/resetpassword` ||  // Reset Password
        req.url == `${environment.apiUrl}/oauth/azure/token` ||  // Token for AzureAD
        req.url == `${environment.apiUrl}/oauth/twofa/generate` ||  // Token for AzureAD
        req.url == `${environment.apiUrl}/oauth/twofa` ||  // Token for AzureAD
        req.url == `${environment.apiUrl}/oauth/token`) {  // Token for UserPassword
        return next.handle(req);
     }

     return this.store.pipe(select(fromAuth.getToken))
      .pipe(
        filter(token => token != null),
        first(),
        withLatestFrom(this.store.pipe(select(fromAuth.getBotId)).pipe(first())),
        flatMap(([token, botId]) => {
          let resolvedBotId = botId;
          if (!resolvedBotId) {
            try {
              const appSettings = JSON.parse(sessionStorage.getItem('appSettings'));
              resolvedBotId = appSettings?.botId;
            } catch {
              resolvedBotId = botId;
            }
          }

          const headers: Record<string, string> = {};
          if (!!token) {
            headers.Authorization = 'Bearer ' + token;
          }
          if (resolvedBotId && !req.headers.has('x-bot-id')) {
            headers['x-bot-id'] = resolvedBotId.toString();
          }

          const authReq = Object.keys(headers).length > 0 ? req.clone({
            setHeaders: headers,
          }) : req;

          return next.handle(authReq);
        }),
      );
  }
}
